import { render, staticRenderFns } from "./Voti.vue?vue&type=template&id=4ab6f2e5&"
import script from "./Voti.vue?vue&type=script&lang=js&"
export * from "./Voti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports